import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: {
        pageTitle: 'Home',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
      },
    },
    {
      path: '/vector-stats/VectorStatsList',
      name: 'vector-stats-list',
      component: () => import('@/views/vector-stats/VectorStatsList.vue'),
      meta: {
        action: 'read',
        breadcrumb: [
          {
            text: 'Estadística Vectores',
          },
        ],
        pageTitle: 'Estadística Vectores',
        text: 'Estadística Vectores',
        resource: 'vector-stats-list',
      },
    },
    {
      path: '/vector-stats/VectorStatsNew',
      name: 'vector-stats-new',
      component: () => import('@/views/vector-stats/VectorStatNew.vue'),
      meta: {
        action: 'read',
        breadcrumb: [
          {
            text: 'Agreagar Estadística Vectores',
          },
        ],
        pageTitle: 'Agregar Estadística Vectores',
        text: 'Agregar Estadística Vectores',
        resource: 'vector-stats-new',
      },
    },



    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
